import FileUploadCard from '../common/FileUploadCard';

const LeistungspaketeImport = () => (
    <main className="w-full py-0 px-2 space-y-8">
        <FileUploadCard uploadUrl="/api/employee/saveEmployees" />
    </main>
);

export default LeistungspaketeImport;